import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "jacinto_cookie_consent_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const stored = window.localStorage.getItem(KEY);
    if (!stored) setShow(true);
  }, []);

  const save = (choice) => {
    try {
      window.localStorage.setItem(
        KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch (_) {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie preferences"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 rounded-2xl border border-white/10 bg-[#0b0b0b]/95 backdrop-blur-xl p-5 shadow-2xl"
    >
      <div className="font-serif text-lg tracking-tight mb-1">
        A discreet note on cookies
      </div>
      <p className="text-zinc-400 text-sm leading-relaxed">
        We use essential cookies to run the atelier and, with your consent, analytics
        to understand traffic. Read our{" "}
        <Link to="/cookies" className="gold underline">Cookie Notice</Link> and{" "}
        <Link to="/privacy" className="gold underline">Privacy Policy</Link>.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          onClick={() => save("accepted")}
          className="btn-gold text-[11px] !py-2 !px-4"
          data-testid="cookie-accept"
        >
          Accept all
        </button>
        <button
          onClick={() => save("essential")}
          className="btn-ghost text-[11px] !py-2 !px-4"
          data-testid="cookie-essential"
        >
          Essential only
        </button>
      </div>
    </div>
  );
}
